module.exports = __webpack_public_path__ + "static/WILLA WALERIA-ca892fba74506b115a3a88f6d6b470d6.mp3";